import { SceneManager } from "./sceneManager.js";
import { createGameScreen } from "./screens/gameScreen.js";
import { leaderboardScreen } from "./screens/leaderboardScreen.js";
import { runResult } from "./runResult.js";
import { startRound, endRound } from "./supabaseClient.js";

const canvas = document.querySelector("canvas.webgl");
const manager = new SceneManager(canvas);

// The menu (and the post-round leaderboard) are just this same screen in
// different camera modes (orbiting showcase camera over the real maze
// earth) - there's no separate scene to load for either, so pressing PLAY
// or finishing a round is a camera/DOM change, not a scene swap. Because
// of that, gameScreen is the only screen ever handed to the SceneManager;
// the leaderboard is a plain DOM overlay shown on top of it.
const gameScreen = createGameScreen({
  // Fires the moment gameplay actually begins - kicks off the server-
  // tracked round session (see startRound() in supabaseClient.js) so its
  // start time is stamped as close to the real start as possible. Runs in
  // parallel with the round itself; the id just needs to have arrived by
  // the time onRoundEnd fires (seconds later), so this doesn't block or
  // delay anything.
  onRoundStart: () => {
    runResult.sessionId = null;
    runResult.endRoundPromise = null;
    runResult.sessionPromise = startRound().then((id) => {
      runResult.sessionId = id;
      return id;
    });
  },
  // Fires synchronously the instant the round is decided (hider caught or
  // timer run out) - see onRoundFinish in gameScreen.js. Stamping the
  // server-side end time here, rather than in onRoundEnd below, gives it
  // the whole ~1.4s celebratory pause to resolve before the leaderboard
  // screen needs the result. Chains off sessionPromise (not sessionId
  // directly) - see the comment on it in runResult.js for why that matters.
  onRoundFinish: () => {
    runResult.endRoundPromise = runResult.sessionPromise.then((id) => endRound(id));
  },
  // async is fine here - gameScreen fires onRoundEnd without awaiting it.
  onRoundEnd: async ({ elapsedSeconds, found }) => {
    runResult.found = found;
    // Use the server's own computed time as "Your time" whenever it's
    // available, so the number displayed here is exactly what
    // submit_leaderboard_score() later writes to the leaderboard (it
    // recomputes from the same two stored timestamps) - not just close to
    // it. Only falls back to the client's locally-ticked timer if the
    // round-end stamp never landed (session expired, network failure).
    const serverSeconds = await runResult.endRoundPromise;
    runResult.elapsedSeconds = serverSeconds ?? elapsedSeconds;
    leaderboardScreen.show({ onDone: () => gameScreen.returnToMenu() });
  },
});

manager.switchTo(gameScreen, {});
